"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAboutHeaderDatabaseNameLinkItem = exports.renderAboutHeaderTagsDetailList = exports.AboutHeaderDescriptionDetailItem = exports.renderEmbeddedAssetDescription = exports.renderAboutHeaderTextDetailItem = exports.renderFileType = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const typestyle_1 = require("typestyle");
function renderFileType(connectionType) {
    const helpText = getHelpTextForFile(connectionType);
    const friendlyConnectionTypeName = (0, data_catalog_shared_1.messageForConnectionType)(connectionType);
    return renderAboutFileTextDetailItem(catalog_messages_1.Messages.FileType(), friendlyConnectionTypeName !== null && friendlyConnectionTypeName !== void 0 ? friendlyConnectionTypeName : '', helpText);
}
exports.renderFileType = renderFileType;
// This is based off of the ConnectToAllowedClasses, will need to manually add new types from that which need this messaging
function getHelpTextForFile(connectionType) {
    switch (connectionType) {
        case 'csv':
        case 'cloudfile:box-semistructpassivestore-direct':
        case 'cloudfile:box-textscan':
        case 'cloudfile:dropbox-semistructpassivestore-direct':
        case 'cloudfile:dropbox-textscan':
        case 'cloudfile:googledrive-semistructpassivestore-direct':
        case 'cloudfile:googledrive-textscan':
        case 'cloudfile:onedrive-semistructpassivestore-direct':
        case 'cloudfile:onedrive-textscan':
        case 'dataengine':
        case 'textclean':
        case 'textscan':
        case 'textscan-reader':
            return catalog_messages_1.Messages.FileSingleTable();
        case 'cloudfile:box-excel-direct':
        case 'cloudfile:dropbox-excel-direct':
        case 'cloudfile:googledrive-excel-direct':
        case 'cloudfile:onedrive-excel-direct':
        case 'excel':
        case 'excel-direct':
        case 'excel-reader':
        case 'google-sheets':
        case 'hyper':
        case 'msaccess':
            return catalog_messages_1.Messages.FileMultipleTables();
        default:
            return '';
    }
}
function renderAboutHeaderTextDetailItem(label, value, testId) {
    return (react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailItem, key: testId },
        react_1.default.createElement(vizportalclient_common_components_1.VerticalFlexContainer, { fillFlexParent: true },
            react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, label),
            react_1.default.createElement("span", { "data-tb-test-id": testId, title: value, className: data_catalog_shared_1.aboutHeaderDetailsTextElide }, value))));
}
exports.renderAboutHeaderTextDetailItem = renderAboutHeaderTextDetailItem;
function renderEmbeddedAssetDescription(testId) {
    return renderTextDetailItem(catalog_messages_1.Messages.DatabaseCategory(), catalog_messages_1.Messages.EmbeddedAsset(), catalog_messages_1.Messages.EmbeddedAssetHelpText(), testId);
}
exports.renderEmbeddedAssetDescription = renderEmbeddedAssetDescription;
function renderAboutFileTextDetailItem(label, value, helpText) {
    return renderTextDetailItem(label, value, helpText, 'table-details-connection-type-test-id');
}
function renderTextDetailItem(label, value, helpText, testId) {
    return (react_1.default.createElement("div", { className: (0, typestyle_1.classes)(data_catalog_shared_1.aboutHeaderDetailItem, data_catalog_shared_1.aboutHeaderConnectionTypeDetailItem), key: testId },
        react_1.default.createElement(vizportalclient_common_components_1.VerticalFlexContainer, { fillFlexParent: true },
            react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, label),
            react_1.default.createElement(vizportalclient_common_components_1.HorizontalFlexContainer, { fillFlexParent: true },
                react_1.default.createElement("div", { "data-tb-test-id": testId, title: value, className: data_catalog_shared_1.aboutHeaderConnectionTypeDetailText }, value),
                react_1.default.createElement("div", { title: helpText, className: data_catalog_shared_1.aboutHeaderConnectionTypeDetailIcon },
                    react_1.default.createElement(catalog_icons_1.SvgInfo, { className: data_catalog_shared_1.aboutHeaderInfoIcon }))))));
}
function AboutHeaderDescriptionDetailItem(props) {
    const { description, testId } = props;
    const markup = react_1.default.createElement(data_catalog_shared_1.FormattedMarkupWrapperInPage, { markup: description });
    const fallback = (react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderPlaceholderText }, catalog_messages_1.Messages.NoDescriptionAvailable()));
    return (react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTags },
        react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, catalog_messages_1.Messages.Description()),
        react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTagsContent, "data-tb-test-id": testId }, description ? markup : fallback)));
}
exports.AboutHeaderDescriptionDetailItem = AboutHeaderDescriptionDetailItem;
function renderAboutHeaderTagsDetailList({ tags }, testId, urls, contentType) {
    const filtered = (0, catalog_core_1.filterOutNullAndUndefined)(tags.map(t => t.name));
    return (react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTags },
        react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, catalog_messages_1.Messages.Tags()),
        react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDescriptionAndTagsContent, "data-tb-test-id": testId }, tags.length === 0
            ? (react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderPlaceholderText }, catalog_messages_1.Messages.NoTagsAvailable()))
            : filtered.map((name, index) => (react_1.default.createElement(react_1.default.Fragment, { key: name },
                react_1.default.createElement(react_router_dom_1.Link, { to: contentType === 'DatabaseTable'
                        ? urls.catalogTablesWithTagPath(name)
                        : urls.catalogDatabasesWithTagPath(name), title: name, className: data_catalog_shared_1.linkClass }, name),
                (tags.length - index) > 1 ? catalog_messages_1.Messages.Comma() : null))))));
}
exports.renderAboutHeaderTagsDetailList = renderAboutHeaderTagsDetailList;
function renderAboutHeaderDatabaseNameLinkItem(label, databaseName, databaseId, testId, urls) {
    return (react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailItem, key: testId },
        react_1.default.createElement(vizportalclient_common_components_1.VerticalFlexContainer, { fillFlexParent: true },
            react_1.default.createElement("div", { className: data_catalog_shared_1.aboutHeaderDetailLabel }, label),
            react_1.default.createElement(react_router_dom_1.Link, { to: urls.catalogDatabasePath(databaseId), title: databaseName, className: data_catalog_shared_1.aboutHeaderDetailsTextElide, "data-tb-test-id": testId }, databaseName))));
}
exports.renderAboutHeaderDatabaseNameLinkItem = renderAboutHeaderDatabaseNameLinkItem;
//# sourceMappingURL=AboutHeaderDetailItems.js.map